import axiosInstance from "../axios/axios";

const getCustomerList = async (id) => {
  try {
    const response = await axiosInstance.get(`/Customer/getAllCustomers/${id}`);
    //console.log("getCustomerList--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error fetching getCustomerList;", error);
  }
};

const addCustomer = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/Customer/addCustomer/${userId}/${companyId}`,
      body,
    );
    //console.log("addCustomer--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error==>", error);
  }
};

const getCustomerCategoryType = (categoryId) => {
  try {
    const response = axiosInstance.get(
      `/Category/getCategoryDetailsByCategoryId/${categoryId}`,
    );
    //console.log("getCustomerCategoryType--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error==>", error);
  }
};

const getCustomerStatus = async (statusTypeId) => {
  try {
    const response = await axiosInstance.get(
      `/Status/getAllStatus/${statusTypeId}`,
    );
    //console.log("getCustomerActiveStatus--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error--->", error);
  }
};

const updateCustomer = async (userId, companyId, body) => {
  try {
    // debugger;
    const response = await axiosInstance.post(
      `/Customer/updateCustomer/${userId}/${companyId}`,
      body,
    );
    //console.log("updateCustomer--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const getCustomerById = async (userId, companyId, id) => {
  try {
    // debugger;
    const response = await axiosInstance.get(
      `/Customer/getCustomerById/${userId}/${companyId}/${id}`,
    );
    //console.log("getCustomerById--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const getStateDropdown = async () => {
  try {
    const response = await axiosInstance.get(`/state/getAllStates`);
    //console.log("getStateDropdown--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const getDepartmentDropdown = async () => {
  try {
    const response = await axiosInstance.get(`/Department/getAllDepartments`);
    //console.log("getDepartmentDropdown", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const getPositionDropdown = async () => {
  try {
    const response = await axiosInstance.get(`/Positions/getAllPositions`);
    //console.log("getPositionDropdown", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const addCustomerContact = async (userId, companyId, customerId, body) => {
  try {
    const response = await axiosInstance.post(
      `/Customer/addCustomerContact/${userId}/${companyId}/${customerId}`,
      body,
    );
    //console.log("addCustomerContact--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};
const intimateCustomer = async (userId, companyId, body) => {
  try {
    //console.log("intimateCustomer===>", userId, companyId, body);
    const response = await axiosInstance.post(
      `/Customer/intimateCustomer/${userId}/${companyId}`,
      body,
      // ,
      // {
      //   timeout: 100000,
      // }
    );
    //console.log("intimateCustomer--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error intimateCustomer===>", error);
  }
};
const updateSelectedSupplierbyCustomer = async (userId, companyId, body) => {
  try {
    // console.log(
    //   "updateSelectedSupplierbyCustomer===>",
    //   userId,
    //   companyId,
    //   bidId,
    //   supplierId
    // );
    const response = await axiosInstance.post(
      `/Customer/updateSelectedSupplierbyCustomer/${userId}/${companyId}`,
      body,
    );
    //console.log("updateSelectedSupplierbyCustomer--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error updateSelectedSupplierbyCustomer===>", error);
  }
};
const addCustomerLoeFile = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/CustomerLoeFile/addCustomerLoeFile/${userId}/${companyId}`,
      body,
    );

    return response;
  } catch (error) {
    console.error("Error fetching addQuoteLoeFile:", error);
  }
};
const getCustomerLoeFiles = async (userId, companyId, customerId) => {
  try {
    const response = await axiosInstance.get(
      `/LoeFile/getLoeFiles/${userId}/${companyId}/${customerId}`,
    );
    return response;
  } catch (error) {
    console.error("Error fetching getQuoteLoeFiles:", error);
  }
};
const addLeadLoeFile = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/LoeFile/addLoeFile/${userId}/${companyId}`,
      body,
    );
    return response;
  } catch (error) {
    console.error("Error fetching addLeadLoeFile:", error);
  }
};

const getCustomerBids = async (body) => {
  try {
    // debugger;
    const response = await axiosInstance.post(`/bid/getAllBids`, body);
    return response;
  } catch (error) {
    console.error("Error fetching getCustomerBids:", error);
  }
};

const createNewCustomerUser = async (
  userId,
  companyId,
  customerId,
  customerName,
  addressId,
  body,
) => {
  try {
    // debugger;
    const response = await axiosInstance.post(
      `/Customer/createCustomerUser/${userId}/${companyId}/${customerId}/${customerName}/${addressId}`,
      body,
    );
    return response;
  } catch (error) {
    console.log("Error in fetching createNewCustomerUser:", error);
  }
};
export const customerService = {
  getCustomerList,
  addCustomer,
  getCustomerCategoryType,
  getCustomerStatus,
  updateCustomer,
  getCustomerById,
  getStateDropdown,
  getDepartmentDropdown,
  getPositionDropdown,
  addCustomerContact,
  intimateCustomer,
  updateSelectedSupplierbyCustomer,
  addCustomerLoeFile,
  getCustomerLoeFiles,
  addLeadLoeFile,
  getCustomerBids,
  createNewCustomerUser,
};
